import { Component, OnInit } from '@angular/core';
import { GlobalComponent } from 'src/app/global/global.component';
import { EditDetailsClient } from './client-parent.model';

@Component({
  selector: 'app-client-parent',
  templateUrl: './client-parent.component.html',
  styleUrls: ['./client-parent.component.scss']
})
export class ClientParentComponent implements OnInit {
  EditOptions: EditDetailsClient = new EditDetailsClient();
  EditData: boolean = false;
  isConsumer: boolean = false;
  isBasicCarePlan: boolean = false;
  isIclsCarePlan: boolean = false;
  isaid: boolean = false;
  ishomeCarePlan: boolean = false;

  constructor(public global: GlobalComponent) {
    this.global.checkforlogout();
  }

  ngOnInit(): void {
    console.log(this.global.globalclientdata,'parent')
    if (this.EditOptions.isnewClient || (this.global.clientId && this.global.globalclientdata)) {
      this.EditData = true;
      this.EditOptions.clientData = this.global.globalclientdata;
      this.EditOptions.clientId = this.global.clientId;
    } else {
      this.EditData = false;
    }
  }

  dataEmitfromChild(event: EditDetailsClient) {
    this.EditData = event.isEdit;
    this.EditOptions = event;
    this.isConsumer = event.iscounsumer;
    this.isaid = event.isaid;
    this.isBasicCarePlan = event.isEditbasicPlan;
    this.isIclsCarePlan = event.isEditiclsPlan;
    this.ishomeCarePlan = event.isEditHomePlan;
  }


}




